module.exports = __webpack_public_path__ + "media/images/ticbali-logo-96985b0e0a34e0f4de1e6e6562df46fa.svg";